import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyD_BjjPn-b-nfWVc46beFJjP5Y1h8BRIbI',
  authDomain: 'dev-portfolio-2025-forest.firebaseapp.com',
  projectId: 'dev-portfolio-2025-forest',
  storageBucket: 'dev-portfolio-2025-forest.firebasestorage.app',
  messagingSenderId: '10187330199',
  appId: '1:10187330199:web:798865ff62587ccb828fd2',
  measurementId: 'G-SLVWF3NB1Q',
}

const initFirebase = () => {
  const app = initializeApp(firebaseConfig)
  getAnalytics(app)
}

export { initFirebase }
